module.exports = __webpack_public_path__ + "img/eclipse-high-angle.f65c8284.png";